/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';
import { TaskContainer } from './styles/PatientViews.styles';
import SearchHeader from '../../components/searchHeader';
import StoplightTable from '../../components/customTables/tasks/stoplightTable';

interface StoplightPageProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const PatientStoplight: FC<StoplightPageProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  return (
    <TaskContainer id="patient-stoplight" data-testid="patient-stoplight">
      <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <StoplightTable searchTerm={searchTerm} />
    </TaskContainer>
  );
};

export default PatientStoplight;
